import React from 'react';

/* Styled Components */
import {
  ProgressBarWrapper,
  ProgressBarBackground,
  ProgressBar as StyledProgressBar,
} from 'styles/common/ProgressBar';

type PropsType = {
  stepsCompleted: number;
  totalSteps: number;
  overrideStyle?: React.CSSProperties;
  overrideNumberStyle?: React.CSSProperties;
};

const ProgressBar = ({
  stepsCompleted,
  totalSteps,
  overrideStyle,
  overrideNumberStyle,
}: PropsType) => {
  const clampedStepsCompleted = Math.max(
    Math.min(stepsCompleted, totalSteps),
    0,
  );
  const progressPercentageString = (
    (clampedStepsCompleted / Math.max(totalSteps, 1)) *
    100
  )
    .toFixed(2)
    .concat('%');
  return (
    <ProgressBarWrapper>
      <ProgressBarBackground
        style={{ width: overrideStyle?.width || '32px', ...overrideStyle }}
      >
        <StyledProgressBar width={progressPercentageString} />
      </ProgressBarBackground>
      <div style={overrideNumberStyle}>
        {clampedStepsCompleted}/{totalSteps}
      </div>
    </ProgressBarWrapper>
  );
};

export default ProgressBar;
